module.exports = {
  products: {
    VOICE_CREDIT: {
      shouldBeDisplayedOnPayment: true,
      paymentDetailTranslation: 'VOICE_CREDIT_PAYMENT_DETAIL',
      unlimitedPaymentDetailTranslation: 'UNLIMITED_VOICE_CREDIT_PAYMENT_DETAIL',
    },
    VOICE: {
      shouldBeDisplayedOnPayment: true,
      paymentDetailTranslation: 'VOICE_CREDIT_PAYMENT_DETAIL',
    },
    DATA_CREDIT: {
      shouldBeDisplayedOnPayment: true,
      paymentDetailTranslation: 'DATA_CREDIT_PAYMENT_DETAIL',
      unlimitedPaymentDetailTranslation: 'UNLIMITED_DATA_CREDIT_PAYMENT_DETAIL',
    },
    DATA: {
      shouldBeDisplayedOnPayment: true,
      paymentDetailTranslation: 'DATA_CREDIT_PAYMENT_DETAIL',
    },
    SMS_CREDIT: {
      shouldBeDisplayedOnPayment: true,
      paymentDetailTranslation: 'SMS_CREDIT_PAYMENT_DETAIL',
      unlimitedPaymentDetailTranslation: 'UNLIMITED_SMS_CREDIT_PAYMENT_DETAIL',
    },
    SMS: {
      shouldBeDisplayedOnPayment: true,
      paymentDetailTranslation: 'SMS_CREDIT_PAYMENT_DETAIL',
    },
    EXTRA_CREDIT: {
      shouldBeDisplayedOnPayment: true,
      paymentDetailTranslation: 'EXTRA_CREDIT_PAYMENT_DETAIL',
    },
    FACEBOOK_DATA_CREDIT: {
      shouldBeDisplayedOnPayment: true,
      paymentDetailTranslation: 'FACEBOOK_DATA_CREDIT_PAYMENT_DETAIL',
    },
    INSTAGRAM_DATA_CREDIT: {
      shouldBeDisplayedOnPayment: true,
      paymentDetailTranslation: 'INSTAGRAM_DATA_CREDIT_PAYMENT_DETAIL',
    },
    YOUTUBE_DATA_CREDIT: {
      shouldBeDisplayedOnPayment: true,
      paymentDetailTranslation: 'YOUTUBE_DATA_CREDIT_PAYMENT_DETAIL',
    },
    PYELLOW: {
      shouldBeDisplayedOnPayment: true,
      paymentDetailTranslation: 'PCUSTO_PAYMENT_DETAIL',
    },
    RYSIM: {
      shouldBeDisplayedOnPayment: false,
    },
    RYMSISDN: {
      shouldBeDisplayedOnPayment: false,
    },
    AYPREMIUMSIMDELIVERY: {
      shouldBeDisplayedOnPayment: true,
      paymentDetailTranslation: 'AYPREMIUMSIMDELIVERY_PAYMENT_DETAIL',
    },
    ROAMING: {
      shouldBeDisplayedOnPayment: true,
    },
    GSTREBATE: {
      shouldBeDisplayedOnPayment: true,
      paymentDetailTranslation: 'GSTREBATE_PAYMENT_DETAIL',
    },
    TO_ZONEA_VOICE: {
      shouldBeDisplayedOnPayment: true,
    },
    TO_ZONEB_VOICE: {
      shouldBeDisplayedOnPayment: true,
    },
    TO_ZONEC_VOICE: {
      shouldBeDisplayedOnPayment: true,
    },
    ROA1_DATA: {
      shouldBeDisplayedOnPayment: true,
    },
    ROA2_DATA: {
      shouldBeDisplayedOnPayment: true,
    },
    ROA1_VOICE: {
      shouldBeDisplayedOnPayment: true,
    },
    ROA2_VOICE: {
      shouldBeDisplayedOnPayment: true,
    },
    BMGM: {
      shouldBeDisplayedOnPayment: true,
      paymentDetailTranslation: 'BMGM_PAYMENT_DETAIL',
    },
    PROMO: {
      shouldBeDisplayedOnPayment: true,
      paymentDetailTranslation: 'PROMO_PAYMENT_DETAIL',
    },
    KAIZEN_PLN: {
      shouldBeDisplayedOnPayment: true,
      paymentDetailTranslation: 'KAIZEN_PLN',
    },
    KAIZEN_SIM: {
      shouldBeDisplayedOnPayment: true,
      paymentDetailTranslation: 'KAIZEN_SIM',
    },
    KAIZEN_PREMIUM_USAGES: {
      shouldBeDisplayedOnPayment: true,
    },
    ESIM: {
      shouldBeDisplayedOnPayment: true,
      paymentDetailTranslation: 'ESIM',
    },
  },
};
